// removed by extract-text-webpack-plugin


// WEBPACK FOOTER //
// node_modules/bookingbug-angular/src/core/-config/font-awesome/font-awesome.config.js